import React, { useState, useEffect, useRef } from "react";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import ReconciliationDeadlineBlock from "./deadlineCard";
import LoaderSimple from "../general/loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Button, Modal } from "@ts-digital/vrc";
import numeral from "numeral";
import Collapsed from "../general/collapsed";
import AddDeadlineForm from "./addDeadlineForm";
import { createDeadlineWithUpload, createDeadlines } from "../../store/actions/deadlines/company";
import { createReconciliationLink, getReconciledSummary, getReconcilableDeadlines } from "../../store/actions/reconciliation/operations";
import FilterDeadlines from "./filterDeadlines";
import { getDeadlinesCounterparts } from "../../store/actions/deadlines/accountant";
import { delay } from "../../libs/utils";
import VaporDrawer from "../general/vapor/drawer";

const ReconciliationDeadlines = (props) => {
  const {
    onReconciliationButtonClick,
    openDeadlineDetail,
    selectedDeadlines,
    setSelectedDeadlines,
    selectedMovements,
    selectedMovementDetails,
    selectedDeadlinesAmount,
    setSelectedDeadlinesAmount,
    disableReconciliationButton,
    deadlines,
    isGettingDeadlines,
    handleSelectedDeadlines,
    handleRemoveDeadlineFromTotal,
    invalidSelectionBiggerDeadlines,
    difference,
    hasCompatibleDeadlines,
    itemUuid,
    managerUuid,
    afterReconciliationEnd,
    filterDone,
    setFilterDone
  } = props;

  // const selectedMovementDetails = selectedMovements;
  const requestBodyDefault = {
    counterpart: {
      description: "",
      taxId: "",
      vatNumber: ""
    },
    itemId: itemUuid,
    managerId: managerUuid,
    scope: "",
    type: "",
    description: {
      title: "",
      details: ""
    },
    status: {
      confirmed: true
    },
    attachments: [],
    totalAmount: difference,
    payment: {
      type: selectedMovementDetails.paymentValue,
      status: selectedMovementDetails.amount < 0 ? "due" : "collect",
      compensation: false,
      mode: {}
    },
    date: moment()
  };

  const dispatch = useDispatch();
  const main = useSelector((state) => state.main);
  const auth = useSelector((state) => state.auth);
  const deadlinesCounterparts = useSelector((state) => state.deadlinesAccountant?.deadlinesCounterparts);
  const [isLoading, setIsLoading] = useState(false);
  const [visualizeAll, setVisualizeAll] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [newDeadlineDialogVisible, setNewDeadlineDialogVisible] = useState(false);
  const [documentsAdded, setDocumentsAdded] = useState([]);

  const [scopeError, setScopeError] = useState(false);
  const [counterpartError, setCounterpartError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [pIvaCounterpartError, setPIvaCounterpartError] = useState(false);
  const [CFCounterpartError, setCFCounterpartError] = useState(false);
  const [filterDeadlinesDrawer, setFilterDeadlinesDrawer] = useState(false);
  const [filteredDeadlines, setFilteredDeadlines] = useState([]);
  const [requestBody, setRequestBody] = useState(requestBodyDefault);
  const [dateError, setDateError] = useState(false);
  const [frequencyDates, setFrequencyDates] = useState({ startDate: null });
  const [documents, setDocuments] = useState([]);
  const [isSave, setIsSave] = useState(false);

  const [startDateFilter, setStartDateFilter] = useState(moment().subtract(2, "y").format("YYYY-MM-DD"));
  const [endDateFilter, setEndDateFilter] = useState(moment().add(2, "y").format("YYYY-MM-DD"));
  const [documentDate, setDocumentDate] = useState(null);
  const [selectedCounterparts, setSelectedCounterparts] = useState([]);
  const [selectedDocumentNumbers, setSelectedDocumentNumbers] = useState([]);
  const [selectedDocumentAmounts, setSelectedDocumentAmounts] = useState([]);

  const deadlinesRef = useRef();

  useEffect(() => {
    dispatch(getDeadlinesCounterparts());
  }, []);

  useEffect(() => {
    setRequestBody({
      ...requestBody,
      scope: selectedMovementDetails.amount < 0 ? "debt" : "credit"
    });
  }, [selectedMovementDetails?.amount]);
  
  useEffect(() => {
    if (!deadlinesRef.current) return undefined;
    let ps = new Scrollbar(deadlinesRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [deadlinesRef?.current]);

  // caso di nuova scadenza creata dello stesso importo del movimento
  useEffect(() => {
    if (newDeadlineDialogVisible) {
      setRequestBody({
        ...requestBody,
        totalAmount: selectedMovementDetails.amount,
        type: selectedMovementDetails.amount < 0 ? "supplier" : "customer",
        payment: {
          status: "verified",
          type: selectedMovementDetails.amount < 0 ? "item_pays" : "item_collect",
          compensation: false,
          mode: { id: "PM05" }
        },
        counterpart: {
          ...requestBody.counterpart,
          description: selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.companyName,
          taxId: selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.taxId,
          vatNumber: selectedMovementDetails.reconciliationHintList?.[0]?.counterParty?.vatNumber
        },
        description: {
          ...requestBody.description,
          title: selectedMovementDetails.description
        },
        scope: selectedMovementDetails.amount < 0 ? "debt" : "credit"
      });
    }
  }, [newDeadlineDialogVisible]);

  useEffect(() => {
    setVisualizeAll(false);
  }, [selectedMovements]);

  useEffect(() => {    
    // setto a false l'isSave se cambia qualche parametro per evitare segnalazioni errori
    setIsSave(false);
  }, [requestBody]);
  
  let deadlinesCounterpartsArrObj;
  if (deadlinesCounterparts !== null && deadlinesCounterparts.length > 0) {
    deadlinesCounterpartsArrObj = deadlinesCounterparts?.map((counterpart) => {
      return {
        description: counterpart
      };
    });
  }

  let subjectives;

  if (filterDone) {
    subjectives = filteredDeadlines?.map((deadline, index) => {
      if (selectedDeadlines.indexOf(deadline.id) > -1 || visualizeAll) {
        return (
          <div key={index}>
            <ReconciliationDeadlineBlock
              deadline={deadline}
              totalAmount={deadline.totalAmount}
              counterpartName={deadline.counterpart?.description}
              date={deadline.date}
              description={deadline.description.details || deadline.description.title}
              openDeadlineDetail={openDeadlineDetail}
              onClick={(value) => {
                handleSelectedDeadlines(value, deadline);
              }}
              selectedDeadlines={selectedDeadlines}
              canSelect={!(selectedDeadlines.indexOf(deadline.id) > -1 && !visualizeAll)}
            />
          </div>
        );
      }
      return null;
    });
  }

  if (!filterDone && hasCompatibleDeadlines) {
    subjectives = deadlines?.map((deadline, index) => {
      if (selectedDeadlines.indexOf(deadline.id) > -1 || visualizeAll) {
        return (
          <div key={index}>
            <ReconciliationDeadlineBlock
              deadline={deadline}
              totalAmount={deadline.totalAmount}
              counterpartName={deadline.counterpart?.description}
              date={deadline.date}
              description={deadline.description.details || deadline.description.title}
              openDeadlineDetail={openDeadlineDetail}
              onClick={(value) => {
                handleSelectedDeadlines(value, deadline);
              }}
              selectedDeadlines={selectedDeadlines}
              canSelect={!(selectedDeadlines.indexOf(deadline.id) > -1 && !visualizeAll)}
            />
          </div>
        );
      }
      return null;
    });
  } else if (!filterDone && !hasCompatibleDeadlines) {
    subjectives = deadlines?.map((deadline, index) => {
      return (
        <div key={`ReconciliationDeadlineBlock_${index}`}>
          <ReconciliationDeadlineBlock
            key={index}
            deadline={deadline}
            totalAmount={deadline.totalAmount}
            counterpartName={deadline.counterpart?.description}
            date={deadline.date}
            description={deadline.description.details || deadline.description.title}
            openDeadlineDetail={openDeadlineDetail}
            onClick={(value) => {
              handleSelectedDeadlines(value, deadline);
            }}
            selectedDeadlines={selectedDeadlines}
            canSelect={!(selectedDeadlines.indexOf(deadline.id) > -1 && !visualizeAll)}
          />
        </div>
      );
    });
  } else if ((filteredDeadlines.length === 0 && filterDone) || (!filterDone && selectedMovements.length > 0 && deadlines.length === 0)) {
    subjectives = (
      <div style={{ marginTop: "40px" }}>
        <div>
          <FontAwesomeIcon
            style={{
              color: "rgb(228, 234, 240)",
              fontSize: "100px",
              cursor: "pointer"
            }}
            icon={["far", "alarm-clock"]}
          />
        </div>
        <div
          style={{
            color: "rgb(0, 80, 117)",
            fontSize: "16px",
            textAlign: "center",
            marginTop: "10px"
          }}
        >
          Nessuna scadenza trovata
        </div>
      </div>
    );
  }

  const getFilteredDeadlines = () => {
    dispatch(getReconcilableDeadlines(
      selectedMovements,
      startDateFilter,
      endDateFilter,
      selectedCounterparts.length > 0 ? selectedCounterparts : null,
      documentDate ? documentDate : null,
      selectedDocumentNumbers.length > 0 ? selectedDocumentNumbers : null,
      selectedDocumentAmounts.length > 0 ? selectedDocumentAmounts : null
    )).then((res) => {
      setFilterDone(true);
      setSelectedDeadlines([]);
      setSelectedDeadlinesAmount(0);
      setFilteredDeadlines(res?.data?.filteredDeadlines);
      setVisualizeAll(true);
      setFilterDeadlinesDrawer(false);
    });
  };

  const onFilterDeadlines = () => {
    getFilteredDeadlines();
    setFilterDeadlinesDrawer(false);
  };

  const onSave = (requestBodyDeadline) => {    
    dispatch(createDeadlines(requestBodyDeadline, true)).then((res) => {      
      setTimeout(() => {
        let linkList = [];
        linkList.push({
          deadlineId: res.id,
          bankTransactionId: selectedMovements[0]
        });
        dispatch(createReconciliationLink(
          auth, main.accountantUuidSelected, main.companyUuidSelected, linkList, "BANK_TRANSACTION"
        ))
          .then(afterReconciliationEnd())
          .then((res) => delay(3000).then(() => dispatch(getReconciledSummary())));
      }, 1000);
    }).catch(res => console.log("Error"));
    setIsLoading(false);
    setDocuments([]);
    setNewDeadlineDialogVisible(false);
  };

  const handleSubmit = () => {
    if (
      requestBody.description.title &&
      requestBody.scope &&
      (requestBody.type || requestBody.scope === "rent" || requestBody.scope === "financing" || requestBody.scope === "recurring_fees") &&
      requestBody.counterpart.description &&
      (requestBody.counterpart.description === "Erario" || requestBody.counterpart.vatNumber || requestBody.counterpart.taxId)
    ) {
      setIsLoading(true);
      setIsSave(true);
      dispatch(createDeadlineWithUpload(
        documentsAdded,
        requestBody,
        documents, // file già esistenti (lato sinistro) ,
        onSave
      ));
    } else {
      setDateError(!requestBody.date);
      setDescriptionError(!requestBody.description.title);
      setScopeError(!requestBody.scope);
      setPIvaCounterpartError(requestBody.counterpart.description !== "Erario" && !requestBody.counterpart.vatNumber && !requestBody.counterpart.taxId);
      setCounterpartError(!requestBody.counterpart.description);
      setCFCounterpartError(requestBody.counterpart.description !== "Erario" && !requestBody.counterpart.vatNumber && !requestBody.counterpart.taxId);
    }
  };

  const renderSelectedDeadlines = (selectedDeadlines) => {
    const selectedDeadlinesList = selectedDeadlines?.map((selectedDeadline) => {
      if (filterDone) {
        return filteredDeadlines?.find((deadline) => deadline.id === selectedDeadline);
      }
      return deadlines?.find((deadline) => deadline.id === selectedDeadline);
    });
    const items = selectedDeadlinesList?.map((deadline, index) => {
      return (
        <div className="dbx-reconciliation-selected-deadline" key={index}>
          <div className="dbx-reconciliation-selected-deadline-info">
            <span className="dbx-reconciliation-selected-deadline-date">
              {`Scadenza ${index + 1}`}: <strong>{moment(deadline?.date).format("DD MMM YYYY")}</strong>
            </span>
            <span>
              <strong>{numeral(Math.abs(deadline?.totalAmount)).format("0,0.00")} €</strong>
            </span>
          </div>
          <div
            className="dbx-reconciliation-selected-deadline-remove"
            onClick={() => {
              if (selectedDeadlines.indexOf(deadline.id) > -1) {
                handleRemoveDeadlineFromTotal(deadline);
              }
            }}
          >
            <FontAwesomeIcon icon={["far", "times"]} />
          </div>
        </div>
      );
    });
    return items;
  };

  return (
    <div className="dbx-reconciliation-deadlines-root">
      <div style={{ display: "flex", color: "rgb(0, 144, 209)" }}>
        <div className="dbx-reconciliation-deadlines-title">{useIntl().formatMessage({ id: "reconciliation.deadlines.title" })}</div>
        <div style={{ display: selectedMovements.length === 0 ? "none" : "flex" }}>
          <Button style={{ marginRight: "20px" }} kind="secondary" onClick={() => setNewDeadlineDialogVisible(true)}>
            <FontAwesomeIcon style={{ fontSize: "14px" }} cursor="pointer" icon={["far", "plus"]} />
          </Button>
          <Button
            kind="secondary"
            onClick={() => {
              setFilterDeadlinesDrawer(true);
              setSelectedCounterparts([]);
              setDocumentDate(null);
              setSelectedDocumentNumbers([]);
              setSelectedDocumentAmounts([]);
              dispatch(getReconcilableDeadlines(
                selectedMovements,
                startDateFilter,
                endDateFilter,
                null,
                null,
                null,
                null
              ));
            }}
          >
            <FontAwesomeIcon style={{ fontSize: "14px" }} cursor="pointer" icon={["far", "filter"]} />
          </Button>
        </div>
      </div>
      <div style={{ display: selectedMovements.length === 0 ? "none" : "" }} className="dbx-reconciliation-deadlines-list">
        <div className="dbx-reconciliation-deadlines-total-sticky-container">
          <div className="dbx-reconciliation-deadlines-total-container">
            <div className="dbx-reconciliation-deadlines-total">
              <Collapsed
                key={"history"}
                isCollapsed={collapsed}
                onClick={() => {
                  setCollapsed(!collapsed);
                }}
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%"
                    }}
                  >
                    <span>{"Scadenze selezionate"}</span>
                    <span style={{ color: "#152935" }}>
                      Totale: <b>{numeral(Math.abs(selectedDeadlinesAmount)).format("0,0.00")} € </b>
                    </span>
                  </div>
                }
              >
                {selectedDeadlines.length > 0 ? renderSelectedDeadlines(selectedDeadlines) : null}
              </Collapsed>
            </div>
            <Button
              disabled={
                selectedMovements.length === 0 ||
                selectedDeadlines.length === 0 ||
                disableReconciliationButton ||
                (invalidSelectionBiggerDeadlines && difference < 0)
              }
              onClick={onReconciliationButtonClick}
              style={{ width: 140, marginLeft: 24 }}
            >
              Associa
            </Button>
          </div>
        </div>
        {!isGettingDeadlines ? (
          <div className="deadlinesContainerScrollable" ref={deadlinesRef}>
            {subjectives}
          </div>
        ) : (
          <div className="dbx-reconciliation-movements-loading">
            <LoaderSimple />
          </div>
        )}
        {!visualizeAll && hasCompatibleDeadlines ? (
          <div className="linkShowOther" onClick={() => setVisualizeAll(true)}>
            Visualizza altre scadenze
          </div>
        ) : null}
        {newDeadlineDialogVisible && (
          <Modal
            visible={newDeadlineDialogVisible}
            title="Crea nuova scadenza"
            onClose={() => setNewDeadlineDialogVisible(false)}
            closable={true}
            outsideClosable={false}
            footer={
              !isLoading ? (
                <div className="dbx-export-deadlines-dialog-footer">
                  <Button kind="secondary" onClick={() => setNewDeadlineDialogVisible(false)}>
                    <FormattedMessage id="generic.cancel" />
                  </Button>
                  <Button onClick={handleSubmit}>
                    <FormattedMessage id="reconciliation.actions.saveAndLinkToMovement" />
                  </Button>
                </div>
              ) : null
            }
          >
            {!isLoading ? (
              <div width="900px">
                <AddDeadlineForm
                  isSave={isSave}
                  selectedMovementDetails={selectedMovementDetails}
                  scopeError={scopeError}
                  setScopeError={setScopeError}
                  counterpartError={counterpartError}
                  setCounterpartError={setCounterpartError}
                  descriptionError={descriptionError}
                  setDescriptionError={setDescriptionError}
                  pIvaCounterpartError={pIvaCounterpartError}
                  setPIvaCounterpartError={setPIvaCounterpartError}
                  CFCounterpartError={CFCounterpartError}
                  setCFCounterpartError={setCFCounterpartError}                  
                  requestBody={requestBody}
                  setRequestBody={setRequestBody}
                  dateError={dateError}
                  setDateError={setDateError}
                  frequencyDates={frequencyDates}
                  setFrequencyDates={setFrequencyDates}
                  documents={documents}
                  setDocuments={setDocuments}
                  inModal={true}
                  setDocumentsAdded={setDocumentsAdded}
                />
              </div>
            ) : (
              <LoaderSimple message="Salvataggio in corso. Si prega di attendere" />
            )}
          </Modal>
        )}
      </div>
      {filterDeadlinesDrawer && (
        <VaporDrawer
          visible={filterDeadlinesDrawer}
          width={700}
          buttons={<Button onClick={() => onFilterDeadlines()}>Applica filtri</Button>}
          onClose={() => {
            setFilterDeadlinesDrawer(false);
            setSelectedCounterparts([]);
            setDocumentDate(null);
            setSelectedDocumentNumbers([]);
            setSelectedDocumentAmounts([]);
          }}
          title={"SCADENZE"}
          subtitle={null}
          titleAlign="center"
        >
          {/*
        <Drawer
          onClose={() => setFilterDeadlinesDrawer(false)}
          headerTitle={"SCADENZE"}
          content={
            <FilterDeadlines
              startDateFilter={startDateFilter}
              setStartDateFilter={setStartDateFilter}
              endDateFilter={endDateFilter}
              setEndDateFilter={setEndDateFilter}
              selectedCounterparts={selectedCounterparts}
              setSelectedCounterparts={setSelectedCounterparts}
              deadlinesCounterparts={deadlinesCounterpartsArrObj}
              dateError={dateError}
              inModal={false}
            ></FilterDeadlines>
          }
          className="deadlinesFilterDrawer"
          footer={true}
          buttonContent={
            <Button onClick={() => onFilterDeadlines()}>
              Applica filtri
            </Button>
          }
        />
        */}
          <FilterDeadlines
            startDateFilter={startDateFilter}
            setStartDateFilter={setStartDateFilter}
            documentDate={documentDate}
            setDocumentDate={setDocumentDate}
            endDateFilter={endDateFilter}
            setEndDateFilter={setEndDateFilter}
            selectedCounterparts={selectedCounterparts}
            setSelectedCounterparts={setSelectedCounterparts}
            deadlinesCounterparts={deadlinesCounterpartsArrObj}
            dateError={dateError}
            inModal={false}
            selectedDocumentNumbers={selectedDocumentNumbers}
            setSelectedDocumentNumbers={setSelectedDocumentNumbers}
            selectedDocumentAmounts={selectedDocumentAmounts}
            setSelectedDocumentAmounts={setSelectedDocumentAmounts}
          ></FilterDeadlines>
        </VaporDrawer>
      )}
    </div>
  );
};

export default ReconciliationDeadlines;
